// Note: extra types exported from `index.d.ts`.
export {gfmFootnoteFromMarkdown, gfmFootnoteToMarkdown} from './lib/index.js'
